/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAExportIcon20Light = forwardRef('ArrowUiShareAExportIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.354 1.646a.5.5 0 0 0-.708.708L17.294 5H13a5 5 0 0 0-5 5v.499a.5.5 0 0 0 1 0v-.498a4 4 0 0 1 4-4h4.294l-2.648 2.647a.5.5 0 0 0 .708.707l2.794-2.794a1.5 1.5 0 0 0 0-2.121l-2.794-2.795Z" }),
        React.createElement("path", { d: "M5.5 3A2.5 2.5 0 0 0 3 5.5v8A2.5 2.5 0 0 0 5.5 16h8a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 1 1 0v1a3.5 3.5 0 0 1-3.5 3.5h-8A3.5 3.5 0 0 1 2 13.5v-8A3.5 3.5 0 0 1 5.5 2h2a.5.5 0 0 1 0 1h-2Z" })));
});
